import { SiteDTO } from '@luminovo/api-contracts';

export function formatInventorySite(inventorySite: SiteDTO): string {
    return inventorySite.name;
}
